<template>
  <div class="error-page">
    <div class="error-content">
      <div class="error-message">
        <h2 class="error-title" :style="{
          color: titleColor,
          fontSize: titleFontSize + 'px'
        }">{{ errorTitle }}</h2>

        <p class="error-text" :style="{
          color: descriptionColor
        }">{{ errorMessage }}</p>

        <p v-if="errorDetails" class="error-details" :style="{
          borderLeftColor: highlightColor,
          color: descriptionColor
        }">{{ errorDetails }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyErrorPage',
  props: {
    titleColor: {
      type: String,
      default: '#2c2d4a'
    },
    descriptionColor: {
      type: String,
      default: '#90919e'
    },
    highlightColor: {
      type: String,
      default: '#e74c3c'
    },
    titleFontSize: {
      type: Number,
      default: 24
    },
    // Error-specific props
    errorTitle: {
      type: String,
      default: 'Access Error'
    },
    errorMessage: {
      type: String,
      required: true
    },
    errorDetails: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Error page styling */
.error-page {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.14);
  border-radius: 25px;
  padding: 15px;
  min-height: 200px;
}

.error-content {
  padding: 2rem;
}

.error-message {
  margin: 1rem 0;
}

.error-title {
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.error-text {
  margin: 1.5rem 0;
  line-height: 1.6;
}

.error-details {
  margin: 1.5rem auto;
  padding: 1rem;
  background-color: #f8f9fa;
  border-left: 4px solid;
  text-align: left;
  font-style: italic;
  max-width: 90%;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SurveyErrorPage.vue